module.exports = __webpack_public_path__ + "img/9788954636025.5af498ae.jpg";